import script from "./BaseTableEmptyContent.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTableEmptyContent.vue?vue&type=script&setup=true&lang=js"

import "./BaseTableEmptyContent.vue?vue&type=style&index=0&id=2f3d6026&lang=scss"

export default script